module.exports = __webpack_public_path__ + "static/media/ciniphilia_react_home.50fa1657.gif";